// 任务类型分类：内置分类 + 已有类型用过的自定义分类；下拉最后一项「＋ 新增分类…」就地输入新分类（存的就是输入的名称）
import { useState } from "react";
import { api } from "../lib/api";
import { useLoad } from "../lib/hooks";

export const CATEGORY_LABELS: Record<string, string> = { query: "查询类", incorporation: "开公司", ep: "EP", dp: "DP", "director-change": "换董事", "address-change": "换地址", annual: "年审", "tax-query": "报税查询", other: "其他" };

export const categoryLabel = (c: string) => CATEGORY_LABELS[c] ?? c;

const ADD = "__add__";

export function CategoryPicker({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  const types = useLoad(() => api.types(true), []);
  const [adding, setAdding] = useState(false);
  const [draft, setDraft] = useState("");
  const [added, setAdded] = useState<string[]>([]);
  // 内置的放前面（「其他」放最后），自定义的按名称排
  const builtin = Object.keys(CATEGORY_LABELS).filter((c) => c !== "other");
  const custom = [...new Set([...(types.data ?? []).map((t) => t.category as string), ...added, value])]
    .filter((c) => c && !(c in CATEGORY_LABELS))
    .sort((a, b) => a.localeCompare(b, "zh"));
  const options = [...builtin, ...custom, "other"];

  const commit = () => {
    const name = draft.trim();
    if (!name) return;
    // 输入的是内置分类的中文名就直接选它，不重复建
    const hit = Object.entries(CATEGORY_LABELS).find(([, label]) => label === name)?.[0];
    const v = hit ?? name;
    if (!hit) setAdded((a) => [...a, v]);
    onChange(v);
    setAdding(false);
    setDraft("");
  };

  if (adding) {
    return (
      <div className="row" style={{ gap: 8 }}>
        <input
          aria-label="新分类名称"
          autoFocus
          value={draft}
          maxLength={30}
          placeholder="输入新分类，例如：公司注销"
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") { e.preventDefault(); commit(); }
            if (e.key === "Escape") { setAdding(false); setDraft(""); }
          }}
        />
        <button type="button" className="btn btn-primary btn-sm" disabled={!draft.trim()} onClick={commit}>添加</button>
        <button type="button" className="btn btn-sm" onClick={() => { setAdding(false); setDraft(""); }}>取消</button>
      </div>
    );
  }
  return (
    <select aria-label="分类" value={value} onChange={(e) => (e.target.value === ADD ? setAdding(true) : onChange(e.target.value))}>
      {options.map((c) => <option key={c} value={c}>{categoryLabel(c)}</option>)}
      <option value={ADD}>＋ 新增分类…</option>
    </select>
  );
}
